module.exports = __webpack_public_path__ + "static/space-measure-dont-c483a0f82f41692609e8db14b33fad01.png";